import { render, staticRenderFns } from "./EntranceCardTemplate.vue?vue&type=template&id=30f20a24&"
import script from "./EntranceCardTemplate.vue?vue&type=script&lang=js&"
export * from "./EntranceCardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports